import React, { useState, useEffect } from 'react';

import SignIn from '../../components/sign-in/SignIn';
import SignUp from '../../components/sign-up/SignUp';

import {
  SignInUpFormContainer,
  SignInUpContainer
} from './LogInSignUpPage.styles';

const LogInSignUpPage = ({ location }) => {
  const [signInUp, setSignInUp] = useState(
    location.pathname === '/signup' ? false : true
  );

  return (
    <SignInUpContainer className="py">
      <SignInUpFormContainer>
        {signInUp ? (
          <SignIn setSignInUp={setSignInUp} />
        ) : (
          <SignUp setSignInUp={setSignInUp} />
        )}
      </SignInUpFormContainer>
    </SignInUpContainer>
  );
};

export default LogInSignUpPage;
